/**
 * Returns the workspace id of the jira avp instance.
 *
 * @returns the workspace id.
 */
export const getAVPWorkspaceId = () => '1d6b5eef-c56f-4a73-bf9e-758cf7eeb7e8';
